module.exports = __webpack_public_path__ + "img/pic_feed_bigsale1_title.3c147e29.png";